import Vue from 'vue'

export default {
    namespaced: true,
    state: {
        contactsType: {items: []},
        bannerType: {items: []},
        duration: {items: []},
        topics: {items: []},
        languages: {items: []},
        listeners: {items: []},
        time_zone: {items: []},
        emoji: {items: []},
        notificationLanguage: {items: []},
        currencyList: {items: []},
        socials: {items: []},
    },
    getters: {
        contactsType(state){
            return state.contactsType.items;
        },
        bannerType(state){
            return state.bannerType.items;
        },
        duration(state){
            return state.duration.items;
        },
        topics(state){
            return state.topics.items;
        },
        languages(state){
            return state.languages.items;
        },
        listeners(state){
            return state.listeners.items;
        },
        time_zone(state){
            return state.time_zone.items;
        },
        emoji(state){
            return state.emoji.items;
        },
        notificationLanguage(state){
            return state.notificationLanguage.items;
        },
        currencyList(state){
            return state.currencyList.items;
        },
        socials(state){
            return state.socials.items;
        },
    },
    mutations: {
        LoadContactsType(state, data){
            state.contactsType = data
        },
        LoadBannerType(state, data){
            state.bannerType = data
        },
        LoadDuration(state, data){
            state.duration = data
        },
        LoadTopics(state, data){
            state.topics = data
        },
        LoadLanguages(state, data){
            state.languages = data
        },
        LoadListeners(state, data){
            state.listeners = data
        },
        LoadTimeZone(state, data){
            state.time_zone = data
        },
        LoadEmoji(state, data){
            state.emoji = data
        },
        LoadNotificationLanguage(state, data){
            state.notificationLanguage = data
        },
        LoadCurrencyList(state, data){
            state.currencyList = data
        },
        LoadSocials(state, data){
            state.socials = data
        },
    },
    actions: {
        LoadContactsType ({ commit }){
            if(!this.state.handbook.contactsType.items.length){
                return new Promise((resolve, reject) => {
                    Vue.http.get('handbook/contacts_type.json')
                        .then(response => response.json())
                        .then(data => {
                            commit('LoadContactsType' ,data);
                            resolve();
                        }, ()=>{
                            reject();
                        } )
                })
            } else{
                return new Promise((resolve, reject) => {
                    resolve();
                })
            }
        },
        LoadBannerType ({ commit }){
            if(!this.state.handbook.bannerType.items.length){
                let url = process.env.NODE_ENV !== 'production' ? 'handbook/banner_type.json' : 'recblock/type';
                return new Promise((resolve, reject) => {
                    Vue.http.get(url)
                        .then(response => response.json())
                        .then(data => {
                            commit('LoadBannerType' ,data);
                            resolve();
                        }, ()=>{
                            reject();
                        } )
                })
            } else{
                return new Promise((resolve, reject) => {
                    resolve();
                })
            }
        },
        LoadDuration ({ commit }){
            if(!this.state.handbook.duration.items.length){
                return new Promise((resolve, reject) => {
                    Vue.http.get('handbook/duration.json')
                        .then(response => response.json())
                        .then(data => {
                            commit('LoadDuration' ,data);
                            resolve();
                        })
                })
            } else{
                return new Promise((resolve, reject) => {
                    resolve();
                })
            }
        },
        LoadTopics ({ commit }) {
            if(!this.state.handbook.topics.items.length){
                return new Promise((resolve, reject) => {
                    Vue.http.get('handbook/topics.json')
                        .then(response => response.json())
                        .then(data => {
                            commit('LoadTopics' , data);
                            resolve();
                        })
                })
            } else{
                return new Promise((resolve, reject) => {
                    resolve();
                })
            }
        },
        LoadTopicsHard({ commit }){
            return new Promise((resolve, reject) => {
                Vue.http.get('handbook/topics.json')
                    .then(response => response.json())
                    .then(data => {
                        commit('LoadTopics' , data);
                        resolve();
                    },
                    ()=>{
                        reject();
                    })
            })
        },
        LoadLanguages ({ commit }){
            if(!this.state.handbook.languages.items.length){
                return new Promise((resolve, reject) => {
                    Vue.http.get('handbook/languages.json')
                        .then(response => response.json())
                        .then(data => {
                            commit('LoadLanguages' ,data);
                            resolve();
                        })
                })
            } else{
                return new Promise((resolve, reject) => {
                    resolve();
                })
            }
        },
        LoadListeners ({ commit }){
            if(!this.state.handbook.listeners.items.length){
                return new Promise((resolve, reject) => {
                    Vue.http.get('handbook/listeners.json')
                        .then(response => response.json())
                        .then(data => {
                            commit('LoadListeners' ,data);
                            resolve();
                        })
                })
            } else{
                return new Promise((resolve, reject) => {
                    resolve();
                })
            }
        },
        LoadTimeZone ({ commit }){
            if(!this.state.handbook.time_zone.items.length){
                return new Promise((resolve, reject) => {
                    Vue.http.get('handbook/time_zone.json')
                        .then(response => response.json())
                        .then(data => {
                            commit('LoadTimeZone' ,data);
                            resolve();
                        })
                })
            } else{
                return new Promise((resolve, reject) => {
                    resolve();
                })
            }
        },
        LoadEmoji ({ commit }){
            if(!this.state.handbook.emoji.items.length){
                let url = process.env.NODE_ENV !== 'production' ? 'handbook/emoji.json' : 'handbook/emoji';

                return new Promise((resolve, reject) => {
                    Vue.http.get(url)
                        .then(response => response.json())
                        .then(data => {
                            commit('LoadEmoji' ,data);
                            resolve();
                        })
                })
            } else{
                return new Promise((resolve, reject) => {
                    resolve();
                })
            }
        },
        LoadNotificationLanguage ({ commit }){
            if(!this.state.handbook.notificationLanguage.items.length){
                let url = process.env.NODE_ENV !== 'production' ? 'handbook/notificationLanguage.json' : 'handbook/notificationLanguage';

                return new Promise((resolve, reject) => {
                    Vue.http.get(url)
                        .then(response => response.json())
                        .then(data => {
                            commit('LoadNotificationLanguage' ,data);
                            resolve();
                        })
                })
            } else{
                return new Promise((resolve, reject) => {
                    resolve();
                })
            }
        },
        LoadCurrencyList ({ commit }){
            if(!this.state.handbook.currencyList.items.length){
                let url = process.env.NODE_ENV !== 'production' ? 'handbook/currencyList.json' : 'handbook/currencyList';

                return new Promise((resolve, reject) => {
                    Vue.http.get(url)
                        .then(response => response.json())
                        .then(data => {
                            commit('LoadCurrencyList' ,data);
                            resolve();
                        })
                })
            } else{
                return new Promise((resolve, reject) => {
                    resolve();
                })
            }
        },
        LoadSocials ({ commit }){

            if(!this.state.handbook || !this.state.handbook.socials || !this.state.handbook.socials.items.length){
                let url = process.env.NODE_ENV !== 'production' ? 'handbook/socials.json' : 'handbook/socials';

                return new Promise((resolve, reject) => {
                    Vue.http.get(url)
                        .then(response => response.json())
                        .then(data => {
                            commit('LoadSocials' ,data);
                            resolve();
                        })
                })
            } else{
                return new Promise((resolve, reject) => {
                    resolve();
                })
            }
        },
    }
};


// WEBPACK FOOTER //
// ./src/store/modules/handbook.js